import * as Yup from 'yup';

const isCheck = (tab: number) => {
  if (tab === 1) {
    return true;
  }
};

export const validationBp = ({ t }: { t: (val: string) => string }) => Yup.object().shape({
  // proc_hierarchy_id: Yup.string()
  //   .typeError('Field must be string !')
  //   .required('Field cannot empty'),
  // board_id: Yup.string()
  //   .typeError('Field must be string !')
  //   .required('Field cannot empty'),
  name: Yup.string()
    .typeError('Field name must be string')
    .required(t('general.validate.bispro_required')),
  // objective: Yup.string()
  //   .typeError("Field objecitve must be string")
  //   .required("Field objecitve cannot empty"),
  // output: Yup.string()
  //   .typeError("Field output must be string")
  //   .required("Field output cannot empty"),
  // competency_type: Yup.string().when([], {
  //   is: () => isCheck(tab),
  //   then: () => Yup.string()
  //     .typeError("Field competency type must be string")
  //     .required("Field competency type cannot empty"),
  // }),
  // competency_name: Yup.string().when([], {
  //   is: () => isCheck(tab),
  //   then: () => Yup.string()
  //     .typeError("Field competency name must be string")
  //     .required("Field competency name cannot empty")
  // }),
  // competency_level: Yup.string().when([], {
  //   is: () => isCheck(tab),
  //   then: Yup.string()
  //     .typeError("Field competency level must be string")
  //     .required("Field competency level cannot empty")
  // }),
  // level_description: Yup.string().when([], {
  //   is: () => isCheck(tab),
  //   then: Yup.string()
  //     .typeError("Field level description must be string")
  //     .required("Field level description cannot empty")
  // }),

  // competencies: Yup.array().when([], {
  //   is: () => {
  //     return true;
  //   },
  //   then: () =>
  //     Yup.array("harus berbentuk array")
  //       .required('Kosong')
  //       .test(
  //         "is-array-valid",
  //         "Competencies tidak boleh kosong",
  //         value => value && value.length > 0
  //       )
  // }),
});
